import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Portafolio`}</h2>
    <ProjectCard title="Bahance" link="https://www.behance.net/francorios" bg="linear-gradient(120deg, #1769ff, #FFFFFF)" mdxType="ProjectCard">
  Aquí podras encontrar alguno de mis últimos trabajos realizados para mis clientes que me permitieron publicar sus ideas.
    </ProjectCard>
    <ProjectCard title="Github" link="https://github.com/FrancoPhoenix?tab=repositories" bg="linear-gradient(45deg, #4078c0, #6e5494, #bd2c00, #c9510c, #6cc644, #fafafa)" mdxType="ProjectCard">
  También he creado ciertos repositorios de prueba y herramientas simples que puedan ser útiles.
    </ProjectCard>
    <ProjectCard title="Youtube" link="https://www.youtube.com/channel/UCq08UZ0UMB01rb1f_rldfZg?sub_confirmation=1" bg="linear-gradient(120deg, #ff0000, #282828)" mdxType="ProjectCard">
  Para maximizar el aprendizaje es necesario compartir lo aprendido, y que mejor enseñando a traves de Fullstacker. 
    </ProjectCard>
    <ProjectCard title="TikTok" link="https://www.tiktok.com/@francophoenix.zero" bg="linear-gradient(45deg, #010101, #69C9D0, #EE1D52, #FFFFFF)" mdxType="ProjectCard">
  Si lo que te agrada más son videos cortos pero educativos y entretenidos, quizás te puede interesar pasarte por aquí 😉
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      